import type { ComponentPropsWithoutRef } from 'react';

import { cn } from '@/lib/utils';

export type FieldContentProps = ComponentPropsWithoutRef<'div'>;

const FieldContent = ({ className, ...props }: FieldContentProps) => {
  return (
    <div
      data-slot="field-content"
      className={cn('group/field-content flex flex-1 flex-col gap-0.5 leading-snug', className)}
      {...props}
    />
  );
};

export default FieldContent;
